import { Alert } from 'components/ui/alert';
import { ApiErrorAlert } from 'components/ui/api-error-alert';
import { SearchInputDebounce } from 'components/Inputs/DebouncedSearchInput';
import { LoadingMessage } from 'components/Loader/LoadingMessage';
import { useAuth } from 'hooks/useAuth';
import { useService } from 'hooks/useService';
import { ApiError } from 'interfaces/api';
import { useQuery } from 'react-query';
import { ContentType } from 'services/abstract';
import { TagsFilter } from './TagsFilter';

interface FilterBarProps {
  onSearchKeywordChange: (name: string) => void;
  onTagChange: (id: number[]) => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  onSearchKeywordChange,
  onTagChange,
}) => {
  const { user } = useAuth();
  const tagService = useService(ContentType.TAGS);
  const {
    data: response,
    isError,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['tags', user?.id],
    queryFn: async () => await tagService.getAllTagsByOwner(user?.id || 0),
  });

  if (isLoading) {
    return <LoadingMessage data-testid="filter-bar-loading-message" />;
  }

  if (isError) {
    return (
      <ApiErrorAlert error={error as ApiError} data-testid="error-message" />
    );
  }

  if (!response || response.data.length === 0) {
    return (
      <Alert variant="info" className="grid h-fit justify-center items-center">
        <div data-testid="empty-message">Aucun tag n&apos;a été trouvé !</div>
      </Alert>
    );
  }
  return (
    <div className="w-full" data-testid="tags-filter">
      <SearchInputDebounce
        id="pageCarto.search"
        className="w-full my-3"
        name="inputSearch"
        placeholder="Recherche ..."
        data-testid="search-input"
        onDebouncedChange={onSearchKeywordChange}
      />

      <TagsFilter tags={response.data} onChange={onTagChange} />
    </div>
  );
};
